import PrivateImage from '../presentation/PrivateImage';
import React, { useEffect, useRef, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import UserService from "../../services/user.service";
import '../../Print.css';
import { logOut } from "../../helpers/logout";
import { Button, Divider, Grid, Toolbar, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import ActionButton from "../form/input/ActionButton";
import Tooltip from "@material-ui/core/Tooltip";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import GeneratedDocumentEmailAction from "./GeneratedDocumentEmailAction";
import EmailIcon from '@material-ui/icons/Email';
import { PDFExport } from '@progress/kendo-react-pdf';
import { getPdfExportProxyProps, savePdfWithEmbeddedImages } from "../../helpers/pdfExport";
import { NotificationManager } from "react-notifications";
import TextInput from "../form/input/TextInput";
import DateInput from "../form/input/DateInput";
import Popup from "../presentation/Popup";
import QRCode from 'qrcode';
import { CurrencyCode, encode, PaymentOptions } from "../../vendor/bysquare/lib/index.js";

// Helper to round to nearest 0.05
function roundToNearest005(value) {
    return Math.round(value * 20) / 20;
}

function formatDateYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
}

function formatDateYYYYMMDDISO(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    seeMore: {
        marginTop: theme.spacing(8),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    toolbarButtons: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1)
        }
    },
    marginElement: {
        margin: theme.spacing(2)
    },
    marginTop: {
        marginTop: theme.spacing(2)
    },
}));

const InvoiceGenerator = (props) => {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper);
    const pdfRef = useRef(null);
    const [qrCode, setQrCode] = useState('');

    const [funeral, setFuneral] = useState({
        contracting_authority: '',
        ca_address: '',
        ca_zip: '',
        ca_city: '',
        ca_phone: '',
        ca_email: '',
        deceased: '',
        service_entities: [],
        product_entities: []
    });

    const [invoice, setInvoice] = useState({
        invoice_number: '',
        issue_date: new Date(),
        due_date: new Date(new Date().setDate(new Date().getDate() + 14)),
        delivery_date: new Date(),
        invoice_created_date: new Date(),
        invoice_due_date: new Date(new Date().setDate(new Date().getDate() + 14)),
        invoice_delivery_date: new Date(),
        invoice_payment_type: 'Prevodom',
        variable_symbol: '',
        constant_symbol: '0308',
        specific_symbol: '',
        payment_method: 'Prevodom',
        notes: ''
    });

    const [showEmailPopup, setShowEmailPopup] = useState(false);
    const [emailAddress, setEmailAddress] = useState('');
    const [sendingEmail, setSendingEmail] = useState(false);
    const [success, setSuccess] = useState(false);
    const [user, setUser] = useState(null);

    const funeral_id = useParams();
    const user_local = JSON.parse(localStorage.getItem('user')).id;

    useEffect(() => {
        UserService.getUser(user_local).then(
            (response) => {
                setUser(response.data);
            },
            (e) => {
                if (e.response?.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
        UserService.getFuneral(funeral_id.funeral_id).then(
            (response) => {
                setFuneral(response.data);
                setEmailAddress(response.data.ca_email || '');
                // Set invoice number from funeral's invoice_id
                const invoiceData = {
                    ...invoice,
                    invoice_number: response.data.invoice_id || '',
                    variable_symbol: response.data.variable_symbol || response.data.invoice_id || '',
                    constant_symbol: response.data.constant_symbol || '0308',
                    specific_symbol: response.data.specific_symbol || '',
                    payment_method: response.data.payment_method || 'Prevodom',
                    notes: response.data.notes || '',
                };
                
                // Load existing invoice dates if they exist
                if (response.data.invoice_created_date) {
                    invoiceData.invoice_created_date = new Date(response.data.invoice_created_date);
                }
                if (response.data.invoice_due_date) {
                    invoiceData.invoice_due_date = new Date(response.data.invoice_due_date);
                }
                if (response.data.invoice_delivery_date) {
                    invoiceData.invoice_delivery_date = new Date(response.data.invoice_delivery_date);
                }
                // Check for invoice_payment_type - use !== undefined to handle empty strings
                if (response.data.invoice_payment_type !== undefined) {
                    invoiceData.invoice_payment_type = response.data.invoice_payment_type;
                }
                
                setInvoice(invoiceData);
            },
            (e) => {
                if (e.response?.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
    }, [funeral_id.funeral_id, user_local, props]);

    // Generate QR code for Slovak payment (Pay by square)
    useEffect(() => {
        if (user && invoice.invoice_number) {
            const totalAmount = calculateTotal();
            const iban = (user.iban || '').replace(/\s/g, '').toUpperCase(); // Remove spaces from IBAN

            const beneficiaryName = (user.account_name || user.name || '').trim();

            if (!iban || !beneficiaryName) {
                setQrCode('');
                return;
            }

            const dueDateValue = invoice.invoice_due_date || invoice.due_date || invoice.issue_date || new Date();
            const paymentDueDate = formatDateYYYYMMDDISO(new Date(dueDateValue));
            const amountRounded = Number(roundToNearest005(totalAmount).toFixed(2));
            const beneficiary = { name: beneficiaryName };

            try {
                // Slovak payment QR code format (PAY by square)
                const qrString = encode({
                    payments: [
                        {
                            type: PaymentOptions.PaymentOrder,
                            amount: amountRounded,
                            currencyCode: CurrencyCode.EUR,
                            variableSymbol: invoice.variable_symbol || undefined,
                            specificSymbol: invoice.specific_symbol || undefined,
                            constantSymbol: invoice.constant_symbol || undefined,
                            paymentNote: `Faktura ${invoice.invoice_number}`,
                            paymentDueDate,
                            beneficiary,
                            bankAccounts: [{ iban }],
                        },
                    ],
                });

                QRCode.toDataURL(qrString, {
                    width: 150, 
                    margin: 1,
                    errorCorrectionLevel: 'M'
                })
                    .then(url => setQrCode(url))
                    .catch(err => {
                        setQrCode('');
                        console.error('QR Code generation error:', err);
                    });
            } catch (err) {
                setQrCode('');
                console.warn('PAY by square QR generation skipped:', err);
            }
        }
    }, [user, invoice, funeral]);

    const handleInvoiceChange = (field) => (e) => {
        let value = e.target.value;
        
        // For date fields, ensure proper formatting
        if (field.includes('date') && value instanceof Date) {
            value = value;  // Keep as Date object, will be serialized to ISO string by axios
        }
        
        // Auto-sync variable_symbol with invoice_number
        const updatedInvoice = { 
            ...invoice, 
            [field]: value
        };
        
        if (field === 'invoice_number') {
            updatedInvoice.variable_symbol = value;
        }
        
        setInvoice(updatedInvoice);
        
        // Prepare updated funeral object with invoice field changes
        const updateData = {
            ...funeral
        };
        
        // Map all fields directly and explicitly
        if (field === 'invoice_number') {
            updateData.variable_symbol = value;
            updateData.invoice_id = value;
        } else if (field === 'issue_date') {
            updateData.issue_date = value;
        } else if (field === 'due_date') {
            updateData.due_date = value;
        } else if (field === 'delivery_date') {
            updateData.delivery_date = value;
        } else if (field === 'invoice_created_date') {
            updateData.invoice_created_date = value;
        } else if (field === 'invoice_due_date') {
            updateData.invoice_due_date = value;
        } else if (field === 'invoice_delivery_date') {
            updateData.invoice_delivery_date = value;
        } else if (field === 'invoice_payment_type') {
            updateData.invoice_payment_type = value;
        } else {
            // For other invoice fields, map directly
            updateData[field] = value;
        }
        
        UserService.updateFuneral(updateData)
            .catch(error => {
                if (error.response?.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                } else {
                    console.error('Error updating funeral:', error);
                }
            });
    };

    const calculateItemTotal = (item) => {
        let price = 0;
        
        // Use invoice_price if available for all types
        if (item.invoice_price) {
            price = parseFloat(item.invoice_price) || 0;
        } else {
            // Otherwise use existing price fields
            if (item.number) {
                price += parseFloat(item.number) || 0;
            }
            if (item.text_cost && item.text_cost.cost) {
                price += parseFloat(item.text_cost.cost) || 0;
            }
        }
        const count = parseFloat(item.count) || 1;
        return price * count;
    };

    const getItemPrice = (item) => {
        let price = 0;
        
        // Use invoice_price if available for all types
        if (item.invoice_price) {
            price = parseFloat(item.invoice_price) || 0;
        } else {
            // Otherwise use existing price fields
            if (item.number) {
                price += parseFloat(item.number) || 0;
            }
            if (item.text_cost && item.text_cost.cost) {
                price += parseFloat(item.text_cost.cost) || 0;
            }
        }
        return price;
    };

    const hasPrice = (item) => {
        // Check invoice_price first for all types
        if (item.invoice_price && parseFloat(item.invoice_price) > 0) {
            return true;
        }
        
        // Otherwise check existing price fields
        return (item.number && parseFloat(item.number) > 0) || 
               (item.text_cost && item.text_cost.cost && parseFloat(item.text_cost.cost) > 0);
    };

    const shouldShowInInvoice = (item) => {
        // Show in invoice only if item has show_invoice = true
        return item.show_invoice === true;
    };

    const calculateSubtotal = () => {
        let total = 0;
        funeral.service_entities?.forEach(item => {
            if (shouldShowInInvoice(item)) {
                total += calculateItemTotal(item);
            }
        });
        funeral.product_entities?.forEach(item => {
            if (shouldShowInInvoice(item)) {
                total += calculateItemTotal(item);
            }
        });
        return total;
    };

    const calculateBaseAmount = () => {
        // Prices include VAT, so extract base amount (price / 1.23)
        const totalWithVAT = calculateSubtotal();
        return totalWithVAT / 1.23;
    };

    const calculateVAT = () => {
        // Extract VAT amount from VAT-inclusive prices
        const totalWithVAT = calculateSubtotal();
        return totalWithVAT - (totalWithVAT / 1.23);
    };

    const calculateTotal = () => {
        // Total is the same as subtotal since prices already include VAT
        return calculateSubtotal();
    };

    const handleExport = () => {
        savePdfWithEmbeddedImages(pdfRef);
    };

    const handleEmailChange = (e) => {
        setEmailAddress(e.target.value);
    };

    const handleSendEmail = async () => {
        if (!emailAddress || !emailAddress.includes('@')) {
            NotificationManager.error('Zadajte platnú emailovú adresu!', 'Chyba', 5000);
            return;
        }

        setSendingEmail(true);

        try {
            const pdfBlob = await savePdfWithEmbeddedImages(pdfRef);
            
            const formData = new FormData();
            formData.append('email', emailAddress);
            formData.append('pdf', pdfBlob, `faktura-${invoice.invoice_number}.pdf`);
            formData.append('funeral_id', funeral._id);
            formData.append('document_type', 'invoice');

            await UserService.sendDocumentByEmail(formData);
            
            NotificationManager.success('Email bol úspešne odoslaný!', 'Úspech', 5000);
            setShowEmailPopup(false);
            setEmailAddress('');
        } catch (error) {
            if (error.response?.status === 401) {
                logOut(props);
                NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
            } else {
                NotificationManager.error('Nepodarilo sa odoslať email!', 'Chyba', 5000);
            }
        } finally {
            setSendingEmail(false);
        }
    };

    const showInvoice = () => {
        if (!user) return <></>;

        return (
            <div className="document-preview-frame" style={{ border: '1px solid #ccc' }}>
                <PDFExport ref={pdfRef} {...getPdfExportProxyProps()} paperSize="A4" scale={0.75}
                    fileName={`faktura_${invoice.invoice_number}`}>
                    <div style={{ 
                        width: '210mm', 
                        minHeight: '297mm', 
                        padding: '15mm', 
                        fontFamily: 'Arial, sans-serif',
                        boxSizing: 'border-box'
                    }}>
                        {/* Header */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '25px' }}>
                            <div style={{ width: '50%' }}>
                                <PrivateImage width={110} src={user.logo} alt="Logo" />
                            </div>
                            <div style={{ width: '50%', textAlign: 'right' }}>
                                <h1 style={{ margin: '0', fontSize: '30px', fontWeight: 'bold' }}>FAKTÚRA</h1>
                                <p style={{ margin: '5px 0', fontSize: '13px' }}>č. {invoice.invoice_number}</p>
                            </div>
                        </div>

                        {/* Supplier and Customer Info */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                            <div style={{ width: '48%' }}>
                                <h3 style={{ margin: '0 0 8px 0', fontSize: '13px', fontWeight: 'bold' }}>Dodávateľ:</h3>
                                <div style={{ fontSize: '11px', lineHeight: '1.5' }}>
                                    <div style={{ fontWeight: 'bold' }}>{user.name}</div>
                                    <div>{user.address}</div>
                                    <div>IČO: {user.ico}</div>
                                    {user.ic_dph && <div>IČ DPH: {user.ic_dph}</div>}
                                    <div>Tel: {user.phone}</div>
                                    <div>Email: {user.email_official}</div>
                                    {user.iban && <div>IBAN: {user.iban}</div>}
                                </div>
                            </div>
                            <div style={{ width: '48%' }}>
                                <h3 style={{ margin: '0 0 8px 0', fontSize: '13px', fontWeight: 'bold' }}>Odberateľ:</h3>
                                <div style={{ fontSize: '11px', lineHeight: '1.5' }}>
                                    <div style={{ fontWeight: 'bold' }}>{funeral.contracting_authority}</div>
                                    <div>{funeral.ca_address}</div>
                                    <div>{funeral.ca_zip} {funeral.ca_city}</div>
                                    <div>Tel: {funeral.ca_phone}</div>
                                    <div>Email: {funeral.ca_email}</div>
                                </div>
                            </div>
                        </div>

                        {/* Deceased Info */}
                        <div style={{ marginBottom: '15px', padding: '8px 12px', backgroundColor: '#f9f9f9', border: '1px solid #ddd' }}>
                            <div style={{ fontSize: '11px' }}>
                                <strong>Zosnulý:</strong> {funeral.deceased}
                            </div>
                        </div>

                        {/* Invoice Details */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                            <div style={{ width: '48%', fontSize: '10px' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '3px 0' }}>Dátum vystavenia:</td>
                                            <td style={{ padding: '3px 0', fontWeight: 'bold', textAlign: 'right' }}>
                                                {new Date(invoice.invoice_created_date).toLocaleDateString('sk-SK')}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '3px 0' }}>Dátum dodania:</td>
                                            <td style={{ padding: '3px 0', fontWeight: 'bold', textAlign: 'right' }}>
                                                {new Date(invoice.invoice_delivery_date).toLocaleDateString('sk-SK')}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '3px 0' }}>Dátum splatnosti:</td>
                                            <td style={{ padding: '3px 0', fontWeight: 'bold', textAlign: 'right' }}>
                                                {new Date(invoice.invoice_due_date).toLocaleDateString('sk-SK')}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div style={{ width: '48%', fontSize: '10px' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '3px 0' }}>Variabilný symbol:</td>
                                            <td style={{ padding: '3px 0', fontWeight: 'bold', textAlign: 'right' }}>
                                                {invoice.variable_symbol}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '3px 0' }}>Konštantný symbol:</td>
                                            <td style={{ padding: '3px 0', fontWeight: 'bold', textAlign: 'right' }}>
                                                {invoice.constant_symbol}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '3px 0' }}>Spôsob úhrady:</td>
                                            <td style={{ padding: '3px 0', fontWeight: 'bold', textAlign: 'right' }}>
                                                {invoice.invoice_payment_type}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Items Table */}
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '18px', fontSize: '11px' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f0f0f0' }}>
                                    <th style={{ border: '1px solid #ddd', padding: '7px', textAlign: 'left' }}>Položka</th>
                                    <th style={{ border: '1px solid #ddd', padding: '7px', textAlign: 'right', width: '85px' }}>EUR bez DPH</th>
                                    <th style={{ border: '1px solid #ddd', padding: '7px', textAlign: 'right', width: '85px' }}>DPH 23%</th>
                                    <th style={{ border: '1px solid #ddd', padding: '7px', textAlign: 'right', width: '85px' }}>EUR s DPH</th>
                                </tr>
                            </thead>
                            <tbody>
                                {funeral.service_entities?.map((item, index) => {
                                    if (!shouldShowInInvoice(item)) return null;
                                    const priceWithVAT = calculateItemTotal(item);
                                    const priceWithoutVAT = priceWithVAT / 1.23;
                                    const vatAmount = priceWithVAT - priceWithoutVAT;
                                    return (
                                        <tr key={`service-${index}`}>
                                            <td style={{ border: '1px solid #ddd', padding: '7px' }}>{item.name}</td>
                                            <td style={{ border: '1px solid #ddd', padding: '7px', textAlign: 'right' }}>
                                                {priceWithoutVAT.toFixed(2)} €
                                            </td>
                                            <td style={{ border: '1px solid #ddd', padding: '7px', textAlign: 'right' }}>
                                                {vatAmount.toFixed(2)} €
                                            </td>
                                            <td style={{ border: '1px solid #ddd', padding: '7px', textAlign: 'right' }}>
                                                {priceWithVAT.toFixed(2)} €
                                            </td>
                                        </tr>
                                    );
                                })}
                                {funeral.product_entities?.map((item, index) => {
                                    if (!shouldShowInInvoice(item)) return null;
                                    const priceWithVAT = calculateItemTotal(item);
                                    const priceWithoutVAT = priceWithVAT / 1.23;
                                    const vatAmount = priceWithVAT - priceWithoutVAT;
                                    return (
                                        <tr key={`product-${index}`}>
                                            <td style={{ border: '1px solid #ddd', padding: '7px' }}>{item.name}</td>
                                            <td style={{ border: '1px solid #ddd', padding: '7px', textAlign: 'right' }}>
                                                {priceWithoutVAT.toFixed(2)} €
                                            </td>
                                            <td style={{ border: '1px solid #ddd', padding: '7px', textAlign: 'right' }}>
                                                {vatAmount.toFixed(2)} €
                                            </td>
                                            <td style={{ border: '1px solid #ddd', padding: '7px', textAlign: 'right' }}>
                                                {priceWithVAT.toFixed(2)} €
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        {/* Totals and QR Code */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '18px' }}>
                            <div style={{ width: '38%' }}>
                                {qrCode && (
                                    <div>
                                        <p style={{ fontSize: '11px', fontWeight: 'bold', marginBottom: '5px' }}>
                                            QR kód na platbu:
                                        </p>
                                        <PrivateImage src={qrCode} alt="QR Code" style={{ width: '130px', height: '130px' }} />
                                    </div>
                                )}
                            </div>
                            <div style={{ width: '58%' }}>
                                <table style={{ width: '100%', fontSize: '12px', marginLeft: 'auto' }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '5px 8px', textAlign: 'right' }}>Základ:</td>
                                            <td style={{ padding: '5px 8px', textAlign: 'right', fontWeight: 'bold', width: '110px' }}>
                                                {calculateBaseAmount().toFixed(2)} €
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: '5px 8px', textAlign: 'right' }}>DPH 23%:</td>
                                            <td style={{ padding: '5px 8px', textAlign: 'right', fontWeight: 'bold' }}>
                                                {calculateVAT().toFixed(2)} €
                                            </td>
                                        </tr>
                                        <tr style={{ backgroundColor: '#f0f0f0', fontSize: '15px' }}>
                                            <td style={{ padding: '9px 8px', textAlign: 'right', fontWeight: 'bold' }}>
                                                Celkom s DPH:
                                            </td>
                                            <td style={{ padding: '9px 8px', textAlign: 'right', fontWeight: 'bold' }}>
                                                {roundToNearest005(calculateTotal()).toFixed(2)} €
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Payment Info */}
                        <div style={{ marginBottom: '18px', fontSize: '11px', padding: '12px', backgroundColor: '#f9f9f9', border: '1px solid #ddd' }}>
                            <h4 style={{ margin: '0 0 8px 0', fontSize: '12px' }}>Platobné údaje:</h4>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>
                                    {user.iban && <div>IBAN: <strong>{user.iban}</strong></div>}
                                </div>
                                <div>
                                    <div>Variabilný symbol: <strong>{invoice.variable_symbol}</strong></div>
                                    <div>Suma: <strong>{roundToNearest005(calculateTotal()).toFixed(2)} €</strong></div>
                                </div>
                            </div>
                        </div>

                        {/* Notes */}
                        {invoice.notes && (
                            <div style={{ marginBottom: '18px', fontSize: '11px' }}>
                                <h4 style={{ margin: '0 0 8px 0', fontSize: '12px' }}>Poznámka:</h4>
                                <p style={{ margin: 0 }}>{invoice.notes}</p>
                            </div>
                        )}

                        {/* Footer */}
                        <div style={{ fontSize: '10px', textAlign: 'center', color: '#666', borderTop: '1px solid #ddd', paddingTop: '12px' }}>
                            <p style={{ margin: '4px 0' }}>
                                Faktúra je vystavená elektronicky a je platná bez podpisu a pečiatky.
                            </p>
                            <p style={{ margin: '4px 0' }}>
                                {user.name} | {user.address} | IČO: {user.ico} | IČ DPH: {user.ic_dph}
                            </p>
                        </div>
                    </div>
                </PDFExport>
            </div>
        );
    };

    return (
        <Container maxWidth="lg" className={classes.seeMore}>
            <div className={classes.root}>
                <Paper className={fixedHeightPaper}>
                    <Grid container>
                        <Grid xs={12} sm={4} md={3} lg={2} item container>
                            <Toolbar>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    className={classes.button}
                                    onClick={() => setSuccess(true)}
                                >
                                    Späť na detaily
                                </Button>
                            </Toolbar>
                        </Grid>
                        <Grid xs={12} sm={8} md={9} lg={10} item container justifyContent='flex-end'>
                            <Toolbar className={`${classes.toolbarButtons} document-actions-toolbar`}>
                                <TextInput
                                    label="Číslo faktúry"
                                    name="invoice_number"
                                    value={invoice.invoice_number}
                                    onChange={handleInvoiceChange('invoice_number')}
                                />
                                <TextInput
                                    label="Spôsob úhrady"
                                    name="invoice_payment_type"
                                    value={invoice.invoice_payment_type}
                                    onChange={handleInvoiceChange('invoice_payment_type')}
                                    select
                                    SelectProps={{
                                        native: true,
                                    }}
                                >
                                    <option value="Prevodom">Prevodom</option>
                                    <option value="Hotovosť">Hotovosť</option>
                                    <option value=""></option>
                                </TextInput>
                                {/* <DateInput
                                    label="Dátum vystavenia"
                                    name="issue_date"
                                    value={invoice.issue_date}
                                    onChange={handleInvoiceChange('issue_date')}
                                />
                                <DateInput
                                    label="Dátum splatnosti"
                                    name="due_date"
                                    value={invoice.due_date}
                                    onChange={handleInvoiceChange('due_date')}
                                /> */}
                                <DateInput
                                    label="Dátum vystavenia"
                                    name="invoice_created_date"
                                    value={invoice.invoice_created_date}
                                    onChange={handleInvoiceChange('invoice_created_date')}
                                />
                                <DateInput
                                    label="Dátum dodania"
                                    name="invoice_delivery_date"
                                    value={invoice.invoice_delivery_date}
                                    onChange={handleInvoiceChange('invoice_delivery_date')}
                                />
                                <DateInput
                                    label="Dátum splatnosti"
                                    name="invoice_due_date"
                                    value={invoice.invoice_due_date}
                                    onChange={handleInvoiceChange('invoice_due_date')}
                                />
                                <ActionButton color="primary">
                                    <Tooltip title="Pdf export">
                                        <PictureAsPdfIcon
                                            fontSize="small"
                                            onClick={handleExport}
                                        />
                                    </Tooltip>
                                </ActionButton>
                                <GeneratedDocumentEmailAction
                                    pdfRef={pdfRef}
                                    funeral={funeral}
                                    user={user}
                                />
                                {/* <ActionButton color="primary">
                                    <Tooltip title="Odoslať emailom">
                                        <EmailIcon
                                            fontSize="small"
                                            onClick={() => setShowEmailPopup(true)}
                                        />
                                    </Tooltip>
                                </ActionButton> */}
                            </Toolbar>
                        </Grid>
                    </Grid>

                    <Divider />
                    <Grid className={classes.marginTop}
                        container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                    >
                        {showInvoice()}
                    </Grid>
                </Paper>
            </div>
            <Popup
                title={'Odoslať faktúru emailom'}
                openPopup={showEmailPopup}
                setOpenPopup={setShowEmailPopup}
                maxW='sm'
                actions={<>
                    <Button color="primary" variant="outlined" onClick={() => setShowEmailPopup(false)}>
                        Zrušiť
                    </Button>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={handleSendEmail}
                        disabled={sendingEmail}
                    >
                        {sendingEmail ? 'Odosiela sa...' : 'Odoslať'}
                    </Button>
                </>}
            >
                <TextInput
                    label="Emailová adresa"
                    name="email"
                    value={emailAddress}
                    onChange={handleEmailChange}
                    type="email"
                    fullWidth
                    autoFocus
                />
            </Popup>
            {success ? <Redirect to={{
                pathname: `/pohreb/${funeral_id.funeral_id}/info`,
                state: { from: props.location, number: 5 }
            }} /> : <></>}
        </Container>
    );
};

export default InvoiceGenerator;
